import { Navigate, Route, Routes } from 'react-router-dom';
import { PageDeviceConfig } from './containers';

export const ConfigurationRoutes = () => {
  return (
    <Routes>
      <Route path="config" element={<PageDeviceConfig />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
